import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, Transition as _Transition, withCtx as _withCtx, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-col lg:flex-row justify-around lg:items-start pt-20" }
const _hoisted_2 = { class: "flex flex-col mx-auto lg:mx-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "text-5xl font-semibold mb-20" }, "CARRINHO:", -1)
const _hoisted_4 = { class: "self-center md:w-1/2 lg:self-start shadow lg:px-28 px-4 py-4 lg:py-14" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-2xl" }, "Resumo do pedido:", -1)
const _hoisted_6 = { class: "flex flex-col gap-4" }
const _hoisted_7 = { class: "flex flex-col my-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  for: "cep",
  class: "text-2xl"
}, "Informe seu CEP", -1)
const _hoisted_9 = { class: "flex flex-col lg:flex-row w-full gap-4" }
const _hoisted_10 = {
  key: 0,
  class: "flex flex-wrap w-full items-center"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  src: "img/LogoIcon.svg",
  class: "animate-loading-spin w-20"
}, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 1,
  class: "grid grid-cols-3 gap-1 w-full"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "font-semibold text-ellipsis text-sm" }
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "flex flex-col my-4" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("strong", null, "Endereço atual:", -1)
const _hoisted_19 = {
  key: 0,
  class: "flex justify-between items-center"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", { class: "font-semibold lg:text-xl" }, "Previsão de entrega:", -1)
const _hoisted_21 = {
  key: 1,
  class: "flex justify-between items-center"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", { class: "font-semibold lg:text-xl my-2" }, "Valor do envio:", -1)
const _hoisted_23 = { class: "flex justify-between items-center" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", { class: "font-semibold lg:text-xl my-4" }, "Valor total dos produtos:", -1)
const _hoisted_25 = { class: "flex justify-between items-center" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", { class: "font-semibold lg:text-xl my-4" }, "Valor final:", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("h4", { class: "font-semibold lg:text-xl my-4" }, " Formas de pagamento (escolha até duas): ", -1)
const _hoisted_28 = { class: "flex flex-col py-5" }
const _hoisted_29 = { class: "shadow w-full p-5" }
const _hoisted_30 = { class: "flex gap-2 items-center justify-start w-full" }
const _hoisted_31 = ["disabled"]
const _hoisted_32 = {
  for: "ZeeCash",
  class: "flex items-center gap-2 font-semibold"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("img", {
  src: "img/LogoIcon.svg",
  class: "w-10"
}, null, -1)
const _hoisted_34 = { key: 0 }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("strong", null, "E-Cash:", -1)
const _hoisted_36 = {
  key: 0,
  class: "flex flex-col gap-2 items-start my-4"
}
const _hoisted_37 = { class: "flex gap-2" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" total em "),
  /*#__PURE__*/_createElementVNode("strong", { class: "text-azul-claro" }, "eCash + Saldo"),
  /*#__PURE__*/_createTextVNode(" atual: ")
], -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("h6", { class: "text-lg" }, [
  /*#__PURE__*/_createTextVNode(" Pague com seu "),
  /*#__PURE__*/_createElementVNode("strong", { class: "text-azul-claro" }, "E-Cash + Saldo"),
  /*#__PURE__*/_createTextVNode(": ")
], -1)
const _hoisted_40 = { class: "my-4 self-center" }
const _hoisted_41 = { class: "text-vermelho-lixeira" }
const _hoisted_42 = { class: "shadow p-5" }
const _hoisted_43 = { class: "flex gap-2 items-center w-20" }
const _hoisted_44 = ["disabled"]
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", {
  for: "pix",
  class: "flex items-center gap-2 font-semibold"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "img/pix.png",
    class: "w-10"
  }),
  /*#__PURE__*/_createTextVNode(" Pix ")
], -1)
const _hoisted_46 = { key: 0 }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("strong", null, "Pix:", -1)
const _hoisted_48 = {
  key: 0,
  class: "flex flex-col gap-2 items-start my-4"
}
const _hoisted_49 = /*#__PURE__*/_createElementVNode("p", { class: "text-cinza-padrao text-sm border-2 border-cinza-padrao rounded p-2 text-center" }, " Você receberá os dados para realizar o pagamento do pix ao finalizar a compra ", -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("h6", { class: "text-lg" }, [
  /*#__PURE__*/_createTextVNode(" Pague com "),
  /*#__PURE__*/_createElementVNode("strong", { class: "text-azul-claro" }, "Pix")
], -1)
const _hoisted_51 = { class: "my-4" }
const _hoisted_52 = { class: "text-vermelho-lixeira" }
const _hoisted_53 = { class: "shadow p-5 w-" }
const _hoisted_54 = { class: "flex gap-2 items-center w-20" }
const _hoisted_55 = ["disabled"]
const _hoisted_56 = /*#__PURE__*/_createElementVNode("label", {
  htmlFor: "creditCard",
  class: "flex items-center gap-2 font-semibold"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "img/card.png",
    class: "w-10"
  }),
  /*#__PURE__*/_createElementVNode("p", { class: "w-44" }, "Cartão de crédito")
], -1)
const _hoisted_57 = {
  key: 0,
  class: "py-2"
}
const _hoisted_58 = /*#__PURE__*/_createElementVNode("strong", null, "Cartão de crédito:", -1)
const _hoisted_59 = {
  key: 0,
  class: "flex flex-col w-72 md:w-full"
}
const _hoisted_60 = /*#__PURE__*/_createElementVNode("h5", { class: "text-xl font-semibold m-4 uppercase mx-auto" }, " Informe os dados do cartão ", -1)
const _hoisted_61 = { class: "w-full flex flex-col gap-2" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("label", {
  class: "font-semibold",
  for: "creditCardValue"
}, "Valor à pagar", -1)
const _hoisted_63 = { class: "text-vermelho-lixeira" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disblaed: "",
  hidden: "",
  selected: ""
}, " Tipo de cartão ", -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("option", { value: "1" }, [
  /*#__PURE__*/_createTextVNode(" Visa "),
  /*#__PURE__*/_createElementVNode("img", {
    src: "img/visa.png",
    class: ""
  })
], -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("option", { value: "2" }, "MasterCard", -1)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("option", { value: "3" }, "Elo", -1)
const _hoisted_68 = [
  _hoisted_64,
  _hoisted_65,
  _hoisted_66,
  _hoisted_67
]
const _hoisted_69 = { class: "flex flex-wrap my-2 w-full" }
const _hoisted_70 = ["for"]
const _hoisted_71 = { key: 0 }
const _hoisted_72 = { class: "text-red-800" }
const _hoisted_73 = { class: "flex gap-2 items-center" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-lg" }, " Validade: ", -1)
const _hoisted_75 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  hidden: "",
  disable: "",
  selected: ""
}, " Mês ", -1)
const _hoisted_76 = ["value"]
const _hoisted_77 = { key: 0 }
const _hoisted_78 = { class: "text-red-800" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  hidden: "",
  disable: "",
  selected: ""
}, " Ano ", -1)
const _hoisted_80 = ["value"]
const _hoisted_81 = { key: 0 }
const _hoisted_82 = { class: "text-red-800" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("h5", { class: "text-xl font-semibold m-4 uppercase mx-auto" }, " Informações pessoais ", -1)
const _hoisted_84 = { class: "flex flex-wrap gap-2 my-2 w-full" }
const _hoisted_85 = ["for"]
const _hoisted_86 = { key: 0 }
const _hoisted_87 = { class: "text-red-800" }
const _hoisted_88 = { class: "flex gap-2 w-full" }
const _hoisted_89 = { class: "flex flex-col break-word w-10/12 gap-1" }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("label", {
  for: "cardCep",
  class: "font-bold"
}, " CEP ", -1)
const _hoisted_91 = { key: 0 }
const _hoisted_92 = { class: "text-red-800" }
const _hoisted_93 = { class: "flex flex-col break-word gap-1 w-2/12" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("label", { class: "font-bold" }, "Estado", -1)
const _hoisted_95 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disblaed: "",
  hidden: "",
  selected: ""
}, " Estado ", -1)
const _hoisted_96 = ["value"]
const _hoisted_97 = { key: 0 }
const _hoisted_98 = { class: "text-red-800" }
const _hoisted_99 = { class: "flex flex-wrap my-2 w-full" }
const _hoisted_100 = ["for"]
const _hoisted_101 = { key: 0 }
const _hoisted_102 = { class: "text-red-800" }
const _hoisted_103 = {
  key: 0,
  class: "text-xl w-2/3 text-red-800"
}
const _hoisted_104 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalPayments = _resolveComponent("ModalPayments")!
  const _component_ModalAddress = _resolveComponent("ModalAddress")!
  const _component_CartItems = _resolveComponent("CartItems")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Input = _resolveComponent("Input")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("form", null, [
    _createVNode(_component_ModalPayments, {
      show: _ctx.showPaymentResult,
      onClose: _ctx.closePixPayment,
      loading: _ctx.loadingPayment,
      regenerate: _ctx.finishPayment,
      restartingQR: _ctx.restartingQR,
      errorMessage: _ctx.errorMessage
    }, null, 8, ["show", "onClose", "loading", "regenerate", "restartingQR", "errorMessage"]),
    _createVNode(_component_ModalAddress, {
      show: _ctx.showAddress,
      userId: _ctx.loginId,
      onCadastro: _ctx.getAddressCadastro,
      onEntrega: _ctx.getAddressEntrega,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAddress = false)),
      data: _ctx.user
    }, null, 8, ["show", "userId", "onCadastro", "onEntrega", "data"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cartItems.slice(1), (cartItem) => {
          return (_openBlock(), _createElementBlock("div", {
            key: cartItem.id
          }, [
            _createVNode(_component_CartItems, { cartItem: cartItem }, null, 8, ["cartItem"])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _withDirectives(_createElementVNode("input", {
                  id: "cep",
                  placeholder: "00000-000",
                  "data-maska": "#####-###",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.cep) = $event)),
                  class: "text-black border-2 px-2 py-1 mt-2 rounded w-full lg:w-5/12 h-12 focus:outline-none"
                }, null, 512), [
                  [_directive_maska],
                  [_vModelText, _ctx.cep]
                ]),
                _createElementVNode("button", {
                  class: "text-lg text-white bg-black rounded px-2 py-1 w-full lg:w-7/12 h-12 lg:my-2 font-semibold",
                  type: "button",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => {
                    _ctx.calculateFreight();
                    _ctx.getSelectedFreight(0, '', 0, '');
                  })
                }, " Calcular frete ")
              ])
            ]),
            _createVNode(_component_el_alert, {
              title: "Atenção!",
              type: "warning",
              description: "A opção 'Retire na loja' é apenas para retirada na matriz da enerzee: Av. Miguel Sutil, 690 - Edifício Verona Tower, 5° andar - Jardim Paulista, Cuiabá - MT, 78065-367",
              "show-icon": ""
            }),
            (_ctx.loading == 'loading')
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
              : _createCommentVNode("", true),
            (_ctx.loading == 'loaded')
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse(
                  JSON.stringify(_ctx.freightOptions.slice(1))
                ), (options) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "flex flex-col items-center gap-1 border-2 border-black p-4 rounded",
                      key: options.Codigo,
                      onClick: ($event: any) => {
                  _ctx.selectedFreight = options.Codigo;
                  console.log(options);
                  _ctx.getSelectedFreight(
                    options.Valor,
                    options.Codigo,
                    options.Prazo,
                    options.Nome
                  );
                }
                    }, [
                      _createVNode(_component_Icon, {
                        icon: "fluent-emoji-high-contrast:package",
                        class: "text-6xl"
                      }),
                      _createElementVNode("p", _hoisted_15, _toDisplayString(options.Nome), 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        class: "w-2 h-2 checked:bg-azul-claro",
                        name: "freight",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedFreight) = $event)),
                        value: options.Codigo
                      }, null, 8, _hoisted_16), [
                        [_vModelRadio, _ctx.selectedFreight]
                      ])
                    ], 8, _hoisted_14))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("p", null, [
                _hoisted_18,
                _createTextVNode(" " + _toDisplayString(_ctx.address.street != '' ?  `${_ctx.address.street},` : '') + " " + _toDisplayString(_ctx.address.number != '' ? `N. ${_ctx.address.number}` : '') + _toDisplayString(_ctx.address.neighborhood != '' ? `, ${_ctx.address.neighborhood}` : '') + " - " + _toDisplayString(_ctx.address.city) + " " + _toDisplayString(_ctx.address.state != '' ? `- ${_ctx.address.state}` : ''), 1)
              ]),
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showAddress = true)),
                class: "bg-black text-white font-bold p-2 rounded flex gap-2 items-center self-end"
              }, [
                _createTextVNode(" Trocar endereço "),
                _createVNode(_component_Icon, { icon: "solar:map-point-wave-bold-duotone" })
              ])
            ])
          ]),
          (_ctx.prompt > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("div", null, [
                  _createElementVNode("p", null, [
                    _createTextVNode(" em "),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.prompt), 1),
                    _createTextVNode(" dias úteis ")
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.prompt > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("p", null, _toDisplayString(new Intl.NumberFormat('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                  minimumFractionDigits: 2,
                }).format(_ctx.fretePrice)), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          _createElementVNode("p", null, _toDisplayString(new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL',
                minimumFractionDigits: 2,
              }).format(_ctx.finalProductPrice)), 1)
        ]),
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _createElementVNode("p", null, _toDisplayString(new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL',
                minimumFractionDigits: 2,
              }).format(_ctx.totalPrice)), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_27,
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _withDirectives(_createElementVNode("input", {
                  id: "ZeeCash",
                  type: "checkbox",
                  value: 4,
                  name: "Payment",
                  class: "checked:bg-azul-claro",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.eCashChoice) = $event)),
                  disabled: (_ctx.pixChoice && _ctx.creditCardChoice) || (_ctx.eCashValue + _ctx.userSaldo == 0)
                }, null, 8, _hoisted_31), [
                  [_vModelCheckbox, _ctx.eCashChoice]
                ]),
                _createElementVNode("label", _hoisted_32, [
                  _hoisted_33,
                  _createElementVNode("p", null, " eCash + Saldo " + _toDisplayString((_ctx.eCashValue + _ctx.userSaldo) != 0
                        ? `(${new Intl.NumberFormat('pt-BR', {
                            style: 'currency',
                            currency: 'BRL',
                            minimumFractionDigits: 2,
                          })
                            .format(_ctx.eCashValue + _ctx.userSaldo)
                            .replace('R', 'E')})`
                        : ''), 1)
                ])
              ]),
              (
                    parseFloat(
                      _ctx.dataEcash.replaceAll('.', '').replace(',', '.')
                    ) != 0
                  )
                ? (_openBlock(), _createElementBlock("p", _hoisted_34, [
                    _hoisted_35,
                    _createTextVNode(" " + _toDisplayString(new Intl.NumberFormat('pt-BR', {
                      style: 'currency',
                      currency: 'BRL',
                      minimumFractionDigits: 2,
                    }).format(
                      parseFloat(
                        _ctx.dataEcash.replaceAll('.', '').replace(',', '.')
                      )
                    )), 1)
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_Transition, { name: "payment-menu" }, {
                default: _withCtx(() => [
                  (_ctx.eCashChoice)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, [
                          _hoisted_38,
                          _createElementVNode("p", null, _toDisplayString(new Intl.NumberFormat('pt-BR', {
                          style: 'currency',
                          currency: 'BRL',
                          minimumFractionDigits: 2,
                        })
                          .format(_ctx.eCashValue + _ctx.userSaldo)
                          .replace('R', 'E')), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_39,
                          _withDirectives(_createElementVNode("input", {
                            placeholder: "0,00",
                            class: "text-black border-2 p-2 text-lg w-full focus:outline-none",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dataEcash) = $event)),
                            onInput: _cache[7] || (_cache[7] = ($event: any) => (
                        _ctx.eCashMask()))
                          }, null, 544), [
                            [_vModelText, _ctx.dataEcash]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_40, [
                          _createElementVNode("p", _hoisted_41, _toDisplayString(_ctx.showMissingValue()), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _withDirectives(_createElementVNode("input", {
                  id: "pix",
                  type: "checkbox",
                  name: "Payment",
                  value: 2,
                  class: "checked:bg-azul-claro",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.pixChoice) = $event)),
                  disabled: _ctx.eCashChoice && _ctx.creditCardChoice
                }, null, 8, _hoisted_44), [
                  [_vModelCheckbox, _ctx.pixChoice]
                ]),
                _hoisted_45
              ]),
              (
                  parseFloat(_ctx.dataPix.replaceAll('.', '').replace(',', '.')) !=
                  0
                )
                ? (_openBlock(), _createElementBlock("p", _hoisted_46, [
                    _hoisted_47,
                    _createTextVNode(" " + _toDisplayString(new Intl.NumberFormat('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                    minimumFractionDigits: 2,
                  }).format(
                    parseFloat(_ctx.dataPix.replaceAll('.', '').replace(',', '.'))
                  )), 1)
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_Transition, { name: "payment-menu" }, {
                default: _withCtx(() => [
                  (_ctx.pixChoice)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                        _hoisted_49,
                        _hoisted_50,
                        _withDirectives(_createElementVNode("input", {
                          placeholder: "0,00",
                          class: "text-black border-2 p-2 text-lg w-full focus:outline-none",
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.dataPix) = $event)),
                          onInput: _cache[10] || (_cache[10] = ($event: any) => (_ctx.pixMask()))
                        }, null, 544), [
                          [_vModelText, _ctx.dataPix]
                        ]),
                        _createElementVNode("div", _hoisted_51, [
                          _createElementVNode("p", _hoisted_52, _toDisplayString(_ctx.showMissingValue()), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("div", _hoisted_54, [
                _withDirectives(_createElementVNode("input", {
                  id: "creditCard",
                  type: "checkbox",
                  name: "Payment",
                  value: 3,
                  class: "checked:bg-azul-claro",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.creditCardChoice) = $event)),
                  disabled: _ctx.pixChoice && _ctx.eCashChoice
                }, null, 8, _hoisted_55), [
                  [_vModelCheckbox, _ctx.creditCardChoice]
                ]),
                _hoisted_56
              ]),
              (
                  parseFloat(
                    _ctx.dataCreditCard.replaceAll('.', '').replace(',', '.')
                  ) != 0
                )
                ? (_openBlock(), _createElementBlock("p", _hoisted_57, [
                    _hoisted_58,
                    _createTextVNode(" " + _toDisplayString(new Intl.NumberFormat('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                    minimumFractionDigits: 2,
                  }).format(
                    parseFloat(
                      _ctx.dataCreditCard.replaceAll('.', '').replace(',', '.')
                    )
                  )), 1)
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_Transition, { name: "payment-menu" }, {
                default: _withCtx(() => [
                  (_ctx.creditCardChoice)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                        _hoisted_60,
                        _createElementVNode("div", _hoisted_61, [
                          _hoisted_62,
                          _withDirectives(_createElementVNode("input", {
                            class: "border-2 p-1 mx-1 mb-2 text-lg w-full focus:border-azul-claro focus:outline-none",
                            placeholder: "00,00",
                            id: "creditCardValue",
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.dataCreditCard) = $event)),
                            onInput: _cache[13] || (_cache[13] = ($event: any) => (_ctx.creditCardMask()))
                          }, null, 544), [
                            [_vModelText, _ctx.dataCreditCard]
                          ])
                        ]),
                        _createElementVNode("p", _hoisted_63, _toDisplayString(_ctx.showMissingValue()), 1),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.typeCard) = $event)),
                          class: "focus:outline-none p-2 font-semibold border-2 bg-white w-44"
                        }, _hoisted_68, 512), [
                          [_vModelSelect, _ctx.form.typeCard]
                        ]),
                        _createElementVNode("div", _hoisted_69, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cardInfo, (item) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: item.id,
                              class: _normalizeClass(item.divStyle)
                            }, [
                              _createElementVNode("label", {
                                class: "font-semibold",
                                for: item.id
                              }, _toDisplayString(item.label), 9, _hoisted_70),
                              _createVNode(_component_Input, {
                                class: _normalizeClass(item.inputStyle),
                                placeholder: item.placeholder,
                                id: item.id,
                                dataMaska: item.mask,
                                value: item.value,
                                onInput: ($event: any) => (item.value = $event.target.value)
                              }, null, 8, ["class", "placeholder", "id", "dataMaska", "value", "onInput"]),
                              (item.error != '')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_71, [
                                    _createElementVNode("p", _hoisted_72, _toDisplayString(item.error), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 2))
                          }), 128))
                        ]),
                        _createElementVNode("div", _hoisted_73, [
                          _hoisted_74,
                          _createElementVNode("div", null, [
                            _createElementVNode("select", {
                              class: "focus:outline-none p-2 border-2 focus:border-azul-claro bg-white w-16",
                              onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.form.month = $event.target.value))
                            }, [
                              _hoisted_75,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.months, (opt) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  value: opt,
                                  key: opt
                                }, _toDisplayString(opt), 9, _hoisted_76))
                              }), 128))
                            ], 32),
                            (_ctx.errors.month !== '')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_77, [
                                  _createElementVNode("p", _hoisted_78, _toDisplayString(_ctx.errors.month), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("select", {
                              class: "focus:outline-none p-2 border-2 focus:border-azul-claro bg-white w-16",
                              onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.form.year = $event.target.value))
                            }, [
                              _hoisted_79,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getYears(), (opt) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  value: opt.toString(),
                                  key: opt
                                }, _toDisplayString(opt), 9, _hoisted_80))
                              }), 128))
                            ], 32),
                            (_ctx.errors.year != '')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_81, [
                                  _createElementVNode("p", _hoisted_82, _toDisplayString(_ctx.errors.year), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _hoisted_83,
                        _createElementVNode("div", _hoisted_84, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.personalInfo.slice(0,2), (item) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: item.id,
                              class: _normalizeClass(item.divStyle)
                            }, [
                              _createElementVNode("label", {
                                class: "font-semibold",
                                for: item.id
                              }, _toDisplayString(item.label), 9, _hoisted_85),
                              _createVNode(_component_Input, {
                                class: _normalizeClass(item.inputStyle),
                                placeholder: item.placeholder,
                                dataMaska: item.mask,
                                id: item.id,
                                value: item.value,
                                onInput: ($event: any) => (item.value = $event.target.value)
                              }, null, 8, ["class", "placeholder", "dataMaska", "id", "value", "onInput"]),
                              (item.error != '')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_86, [
                                    _createElementVNode("p", _hoisted_87, _toDisplayString(item.error), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 2))
                          }), 128))
                        ]),
                        _createElementVNode("div", _hoisted_88, [
                          _createElementVNode("div", _hoisted_89, [
                            _hoisted_90,
                            _withDirectives(_createElementVNode("input", {
                              id: "cardCep",
                              placeholder: "00000-000",
                              class: "focus:outline-none p-1 border-2 focus:border-azul-claro",
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.cep) = $event)),
                              "data-maska": "#####-###"
                            }, null, 512), [
                              [_directive_maska],
                              [_vModelText, _ctx.form.cep]
                            ]),
                            (_ctx.errors.cep != '')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_91, [
                                  _createElementVNode("p", _hoisted_92, _toDisplayString(_ctx.errors.cep), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_93, [
                            _hoisted_94,
                            _withDirectives(_createElementVNode("select", {
                              class: "focus:outline-none p-2 border-2 focus:border-azul-claro bg-white",
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.state) = $event))
                            }, [
                              _hoisted_95,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.states, (state) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: state.acronym,
                                  value: state.state.toLowerCase()
                                }, _toDisplayString(state.acronym), 9, _hoisted_96))
                              }), 128))
                            ], 512), [
                              [_vModelSelect, _ctx.form.state]
                            ]),
                            (_ctx.errors.state != '')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_97, [
                                  _createElementVNode("p", _hoisted_98, _toDisplayString(_ctx.error.state), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_99, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.personalInfo.slice(2), (item) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: item.id,
                              class: _normalizeClass(item.divStyle)
                            }, [
                              _createElementVNode("label", {
                                class: "font-semibold",
                                for: item.id
                              }, _toDisplayString(item.label), 9, _hoisted_100),
                              _createVNode(_component_Input, {
                                class: _normalizeClass(item.inputStyle),
                                placeholder: item.placeholder,
                                id: item.id,
                                dataMaska: item.mask,
                                value: item.value,
                                onInput: ($event: any) => (item.value = $event.target.value)
                              }, null, 8, ["class", "placeholder", "id", "dataMaska", "value", "onInput"]),
                              (item.error != '')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_101, [
                                    _createElementVNode("p", _hoisted_102, _toDisplayString(item.error), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 2))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        (_ctx.messageFailPayment != '')
          ? (_openBlock(), _createElementBlock("p", _hoisted_103, _toDisplayString(_ctx.messageFailPayment), 1))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["text-xl text-white bg-black rounded px-2 py-1 w-full text-center mt-5", _ctx.selectedFreight == '' ? 'opacity-40' : 'opacity-100']),
          disabled: _ctx.selectedFreight == '',
          onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.finishPayment()))
        }, _toDisplayString(_ctx.selectedFreight == ''
              ? 'SELECIONE UMA OPÇÃO DE FRETE'
              : 'FINALIZAR O PAGAMENTO'), 11, _hoisted_104)
      ])
    ])
  ]))
}